var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"movie"},_vm._l((9),function(i){return _c('div',{key:i,staticClass:"movie--item skeleton"},[_c('div',{staticClass:"skeleton-loading"})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }